import { render, staticRenderFns } from "./SimpleCardView.vue?vue&type=template&id=2113a048&scoped=true"
import script from "./SimpleCardView.vue?vue&type=script&lang=js"
export * from "./SimpleCardView.vue?vue&type=script&lang=js"
import style0 from "./SimpleCardView.vue?vue&type=style&index=0&id=2113a048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113a048",
  null
  
)

export default component.exports